import { KnowEdmTableData } from './table-enums.js';

const tieOnMap = new Map();

tieOnMap.set(KnowEdmTableData.TieOnReference, {
  key: KnowEdmTableData.TieOnReference,
  label: 'Tie On Reference',
  unit: '',
});

tieOnMap.set(KnowEdmTableData.TieOnDepthReference, {
  key: KnowEdmTableData.TieOnDepthReference,
  label: 'Tie On Depth Reference',
  unit: '',
});

tieOnMap.set(KnowEdmTableData.TieOnPosition, {
  key: KnowEdmTableData.TieOnPosition,
  label: 'Tie On Position',
  unit: '',
});

export { 
  tieOnMap,
};